import { Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articlesData } from "@/mocks/articles";

export default function BlogList() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuyspreadsheet.icu";

    const bcScript = document.createElement("script");
    bcScript.type = "application/ld+json";
    bcScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
        { "@type": "ListItem", "position": 2, "name": "Blog", "item": `${siteUrl}/blog` },
      ]
    });
    document.head.appendChild(bcScript);

    return () => {
      document.head.removeChild(bcScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-background-100 pt-28 md:pt-32 pb-8 md:pb-12">
        <div className="container-wide">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-wider mb-2">
              Blog
            </span>
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
              Kakobuy Spreadsheet Guides
            </h1>
            <p className="text-sm md:text-base text-foreground-600">
              In-depth articles about the kakobuy spreadsheet to help you shop smarter and safer.
            </p>
          </div>
        </div>
      </section>

      <section className="container-wide py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {articlesData.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-white rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <p className="text-xs text-primary-600 font-medium mb-2">{article.date}</p>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}